import React, { useState, useEffect } from 'react';
import {BrowserUpgradeContainer} from '../smart/utils/browser-upgrade/BrowserUpgradeContainer';
import {Header} from '../dumb/header/Header';
import { Loader } from './utils/loader/Loader';
// import logo from '../images/logo.svg';
import './App.scss';

export const App = () => {

  const [isOnline, setIsOnline] = useState(false);
  // const [language, setLanguage] = useState("IT-it");

  useEffect( () => 

    setIsOnline(true), [setIsOnline]
  );

  if (isOnline === false) {

    return <Loader />
  }
  else
    return <div id="app-container">
      {/**browser upgrade ? */}
      <BrowserUpgradeContainer />
      {/**header component */}
      <Header /> 
      {/**slider component */}
      {/* <Slider /> */}
      {/**service area component */}
      {/* <ServiceArea /> */}
  </div>
}
